/**
 * FlatTreeItem Props
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
